<template>
  <div>
    <Header />
    <SubNav />
    <router-view :key="key" />
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/common/Header";
import SubNav from "@/components/common/SubNav";
import Footer from "@/components/common/Footer";

export default {
  name: "MainLayout",
  components: {
    Header,
    SubNav,
    Footer,
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>
